import React, { useState } from "react";
import emailjs from "emailjs-com";
import "../style/ContactForm.css";
import img from "../assets/images/contactUS3.webp";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_ax3iebr", // Replace with your EmailJS Service ID
        "template_v2jx4wm", // Replace with your EmailJS Template ID
        {
          from_name: "EmailJs",
          last_name: "System",
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          company: formData.company,
          message: formData.message,
          // to_email: "sales@steelxengg.com", // Recipient email
        },
        "xafVyDdQE17NchW4b" // Replace with your EmailJS User ID
      )
      .then(
        (response) => {
          alert("Message sent successfully!");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            company: "",
            message: "",
          });
        },
        (error) => {
          alert("Failed to send message, please try again.");
        }
      );
  };

  return (
    <div className="contact-wrapper">
      <div className="contact-container">
        <h2>
          HAVE SOME <span className="highlight">QUESTIONS?</span>
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            maxLength="10"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="company"
            placeholder="Company Name"
            value={formData.company}
            onChange={handleChange}
            required
          />
          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
      <div className="contact-image">
        <img src={img} alt="contact us feature image" />
      </div>
    </div>
  );
};

export default ContactForm;
